<template>
  <NConfigProvider
    :date-locale="dateEnUS"
    :locale="enUS"
    :theme="getDarkTheme"
    :theme-overrides="getThemeOverrides"
  >
    <AppProvider>
      <!-- <RouterView v-if="!isLock" />

      <transition v-if="isLock && $route.name !== 'login'" name="slide-up">
        <LockScreen />
      </transition> -->

      <Suspense>
        <RouterView />
      </Suspense>
    </AppProvider>
  </NConfigProvider>
</template>

<script lang="ts" setup>
  import { computed, onMounted, onUnmounted } from 'vue';
  import { darkTheme, dateEnUS, enUS } from 'naive-ui';
  // import { LockScreen } from '@/components/Lockscreen';
  import { AppProvider } from '@/components/Application';
  // import { useLockscreenStore } from '@/store/modules/lockscreen';
  // import { useRoute } from 'vue-router';
  import { useDesignSettingStore } from '@/store/modules/designSetting';
  import { lighten } from '@/utils';

  // const route = useRoute();
  // const useLockscreen = useLockscreenStore();
  const designStore = useDesignSettingStore();

  // const isLock = computed(() => useLockscreen.isLock);
  // const lockTime = computed(() => useLockscreen.lockTime);

  /**
   * @type import('naive-ui').GlobalThemeOverrides
   */
  const getThemeOverrides = computed(() => {
    const appTheme = designStore.appTheme;
    const lightenStr = lighten(designStore.appTheme, 6);
    const infoColor = '#005293';
    const infoColorLightenStr = lighten(infoColor, 6);
    const warningColor = '#E05206';
    const warningColorLightenStr = lighten(warningColor, 6);
    return {
      common: {
        primaryColor: appTheme,
        primaryColorSuppl: appTheme,
        primaryColorHover: lightenStr,
        primaryColorPressed: lightenStr,
        infoColor: infoColor,
        infoColorSuppl: infoColor,
        infoColorHover: infoColorLightenStr,
        infoColorPressed: infoColorLightenStr,
        warningColor: warningColor,
        warningColorSuppl: warningColor,
        warningColorHover: warningColorLightenStr,
        warningColorPressed: warningColorLightenStr,
      },
      LoadingBar: {
        colorLoading: appTheme,
      },
      Layout: {
        colorEmbedded: '#f5f7f9',
      },
    };
  });

  const getDarkTheme = computed(() => (designStore.darkTheme ? darkTheme : undefined));

  // let timer;

  // const timekeeping = () => {
  //   clearInterval(timer);
  //   if (route.name == 'login' || isLock.value) return;
  //   // 设置不锁屏
  //   useLockscreen.setLock(false);
  //   // 重置锁屏时间
  //   useLockscreen.setLockTime();
  //   timer = setInterval(() => {
  //     // 锁屏倒计时递减
  //     useLockscreen.setLockTime(lockTime.value - 1);
  //     if (lockTime.value <= 0) {
  //       // 设置锁屏
  //       useLockscreen.setLock(true);
  //       return clearInterval(timer);
  //     }
  //   }, 1000);
  // };

  // onMounted(() => {
  //   document.addEventListener('mousedown', timekeeping);
  // });

  // onUnmounted(() => {
  //   document.removeEventListener('mousedown', timekeeping);
  // });
</script>
